<template>
  <transition
    enter-active-class="duration-500"
    leave-active-class="duration-500"
  >
    <div class="fixed inset-0 overflow-hidden z-20" v-show="visible">
      <div class="absolute inset-0 overflow-hidden">
        <!--
        Background overlay, show/hide based on slide-over state.

        Entering: "ease-in-out duration-500"
          From: "opacity-0"
          To: "opacity-100"
        Leaving: "ease-in-out duration-500"
          From: "opacity-100"
          To: "opacity-0"
      -->
        <transition
          enter-active-class="ease-in-out duration-500"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in-out duration-500"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="visible"
            class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          ></div>
        </transition>

        <section
          class="absolute inset-y-0 right-0 pl-10 max-w-full flex sm:pl-16"
        >
          <!--
          Slide-over panel, show/hide based on slide-over state.

          Entering: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-full"
            To: "translate-x-0"
          Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-0"
            To: "translate-x-full"
        -->

          <transition
            enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
            enter-class="translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
            leave-class="translate-x-0"
            leave-to-class="translate-x-full"
          >
            <div class="w-screen" :class="size" v-show="visible">
              <div
                class="h-full flex flex-col bg-white shadow-xl overflow-y-scroll overflow-x-hidden"
              >
                <!-- Content -->
                <slot>Slot</slot>
              </div>
            </div>
          </transition>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Slideover",
  data() {
    return {};
  },
  props: {
    title: String,
    footer: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "max-w-xl"
    }
  },
  created() {},
  components: {},
  computed: {},
  methods: {}
};
</script>

<style></style>
